import constants from '../constants.js';

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly = {
  displayName: 'Specified Passenger Types Only',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.SpecifiedPassengerTypesOnly',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType = {
  displayName: 'CabinType',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.CabinType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares = {
  displayName: 'Private Fares',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.PrivateFares',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes = {
  displayName: 'Passenger Type Codes',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.PassengerTypes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes = {
  displayName: 'Rate Codes (Corporate Code/Snap Code)',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.RateCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass = {
  displayName: 'Fare Class',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.FareClass',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItem = {
  displayName: 'Item',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass, AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes, AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes, AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares, AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'airCarrierGDSFarSetItem',
  canDelete: true
};

const AirlineCarrierFareGdsSettingsFaresItemFareData = {
  displayName: 'GDS Fare Settings',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareGdsSettingsFaresItemFareDataItem,
  gridCols:
    [{name: 'FareClass', key: 'FareClass'},
      {name: 'RateCodes', key: 'RateCodes'},
      {name: 'PassengerTypes', key: 'PassengerTypes'},
      {name: 'PrivateFares', key: 'PrivateFares'},
      {name: 'CabinType', key: 'CabinType'}]
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes = {
  displayName: 'Excluded Tax Codes',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.ExcludedTaxCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType = {
  displayName: 'Search Type',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.SearchType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GdsFareSearchSearchType'
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType = {
  displayName: 'Search Group Type',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.SearchGroupType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GdsFareSearchGroupType'
};

const AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries = {
  displayName: 'Countries',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesCountryFareClassFareBasisCodes = {
  displayName: 'Fare Basis Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.FareBasisCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesCountryFareClassBrandCodes = {
    displayName: 'Brand Codes',
    dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.BrandCodes',
    displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesCountryFareClassBookingCodes = {
  displayName: 'Booking Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.BookingCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesCountryFareClassBrandName = {
  displayName: 'Brand Name',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.BrandName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareClassesCountryFareClassCountries = {
  displayName: 'Countries',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsFaresItem = {
  displayName: 'Item',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes, AirlineCarrierFareGdsSettingsFaresItemFareData],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'airGdsFareItem',
  canDelete: true
};

const AirlineCarrierFareClassesCountryFareClassItem = {
  displayName: 'Item',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareClassesCountryFareClassCountries, AirlineCarrierFareClassesCountryFareClassBrandName, AirlineCarrierFareClassesCountryFareClassBookingCodes, AirlineCarrierFareClassesCountryFareClassFareBasisCodes, AirlineCarrierFareClassesCountryFareClassBrandCodes],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirFareClsCuFareClsItem',
  canDelete: true
};

const AirlineCarrierFareGdsSettingsFares = {
  displayName: 'Fares',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareGdsSettingsFaresItem,
  gridCols:
    [{name: 'Countries', key: 'Countries'},
      {name: 'SearchGroupType', key: 'SearchGroupType'},
      {name: 'SearchType', key: 'SearchType'},
      {name: 'ExcludedTaxCodes', key: 'ExcludedTaxCodes'}]
};

const AirlineCarrierFareGdsSettingsPriceQuotesCountries = {
  displayName: 'Countries',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.PriceQuotes.$airGdsQuotesItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsPriceQuotesByBrand = {
  displayName: 'PQ by Brand',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.PriceQuotes.$airGdsQuotesItem.PriceQuoteByBrand',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirlineCarrierFareGdsSettingsPriceQuotesItem = {
  displayName: 'Item',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.PriceQuotes.$airGdsQuotesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareGdsSettingsPriceQuotesCountries, AirlineCarrierFareGdsSettingsPriceQuotesByBrand],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'airGdsQuotesItem',
  canDelete: true
};

const AirlineCarrierFareGdsSettingsPriceQuotes = {
  displayName: 'Price Quote',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.PriceQuotes',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareGdsSettingsPriceQuotesItem,
  gridCols: 
    [{name: 'Countries', key: 'Countries'},
    {name: 'Store PQ by Brand', key: 'PriceQuoteByBrand'}]
};

const AirlineCarrierFareGdsSettingsPreferredCountries = {
  displayName: 'Preferred Country Pairs',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.PreferredCountries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareGdsSettingsName = {
  displayName: 'Name',
  dataAt: 'GdsSettings.$AirFareGdsSetItem.Name',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GDSProviders'
};

const AirlineCarrierFareClassesCountryFareClass = {
  displayName: 'Country Fare Class',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareClassesCountryFareClassItem,
  gridCols:
    [{name: 'Countries', key: 'Countries'},
      {name: 'Brand Name', key: 'BrandName'},
      {name: 'Codes', key: 'BookingCodes'},
      {name: 'Fare Basis', key: 'FareBasisCodes'},
      {name: 'Brands', key: 'BrandCodes'}]
};

const AirlineCarrierFareClassesGroupType = {
  displayName: 'Group Type',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.GroupType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareClassesFareBasisCodes = {
  displayName: 'Fare Basis Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.FareBasisCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesBrandCodes = {
    displayName: 'Brand Codes',
    dataAt: 'FareClasses.$AirCarrierFaClassItem.BrandCodes',
    displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesBookingCodes = {
  displayName: 'Booking Codes',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.BookingCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareClassesBrandName = {
  displayName: 'Brand Name',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.BrandName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareClassesTitle = {
  displayName: 'Title',
  dataAt: 'FareClasses.$AirCarrierFaClassItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierCountryCheckInUrl = {
  displayName: 'Check-in Url',
  dataAt: 'CountryData.$AirCountryDataItem.CheckInUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierCountryDataCountry = {
  displayName: 'Country Data',
  dataAt: 'CountryData.$AirCountryDataItem.Country',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierFareGdsSettingsItem = {
  displayName: 'Item',
  dataAt: 'GdsSettings.$AirFareGdsSetItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareGdsSettingsName, AirlineCarrierFareGdsSettingsPreferredCountries, AirlineCarrierFareGdsSettingsFares, AirlineCarrierFareGdsSettingsPriceQuotes],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirFareGdsSetItem',
  canDelete: true
};

const AirlineCarrierFareClassesGridItem = {
  displayName: 'Fare Class',
  dataAt: 'FareClasses.$AirCarrierFaClassItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierFareClassesTitle, AirlineCarrierFareClassesBrandName, AirlineCarrierFareClassesBookingCodes, AirlineCarrierFareClassesFareBasisCodes, AirlineCarrierFareClassesBrandCodes, AirlineCarrierFareClassesGroupType, AirlineCarrierFareClassesCountryFareClass],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirCarrierFaClassItem',
  canDelete: true
};

const AirlineCarrierCountryDataGridItem = {
  displayName: 'Country Data',
  dataAt: 'CountryData.$AirCountryDataItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AirlineCarrierCountryDataCountry, AirlineCarrierCountryCheckInUrl],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId',
  removeParamId: 'AirCountryDataItem',
  canDelete: true
};

const AirlineCarrierModifiedOn = {
  displayName: 'Modified On',
  dataAt: 'ModifiedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierModifiedBy = {
  displayName: 'Modified By',
  dataAt: 'ModifiedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierCreatedOn = {
  displayName: 'Created On',
  dataAt: 'CreatedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierCreatedBy = {
  displayName: 'Created By',
  dataAt: 'CreatedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AirlineCarrierPartnerAirlines = {
  displayName: 'Partner Airlines',
  dataAt: 'PartnerAirlines',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierFareRulesDocument = {
  displayName: 'Fare Rules Document',
  dataAt: 'FareRulesDocument',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'FlightFareRule',
  uploadType: 'pdf'
};

const AirlineCarrierFareGdsSettings = {
  displayName: 'GDS Fare Settings',
  dataAt: 'GdsSettings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AirlineCarrierFareGdsSettingsItem,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'Preferred Countries', key: 'PreferredCountries'}]
};

const AirlineCarrierFareClasses = {
  displayName: 'Fare Classes',
  dataAt: 'FareClasses',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: AirlineCarrierFareClassesGridItem,
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Brand', key: 'BrandName'},
      {name: 'Codes', key: 'BookingCodes'},
      {name: 'Fare Basis', key: 'FareBasisCodes'},
      {name: 'Brands', key: 'BrandCodes'}]
};

const AirlineCarrierCountryData = {
  displayName: 'Country Data',
  dataAt: 'CountryData',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: AirlineCarrierCountryDataGridItem,
  gridCols:
    [{name: 'Country', key: 'Country'},
      {name: 'Check-in Url', key: 'CheckInUrl'}]
};

const AirlineCarrierMediumImageUrl = {
  displayName: 'Medium Image Url',
  dataAt: 'MediumImageUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'FlightCarrier',
  uploadType: 'image'
};

const AirlineCarrierCarrierLogoUrl = {
  displayName: 'Carrier Logo Url',
  dataAt: 'CarrierLogoUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'FlightCarrier',
  uploadType: 'image'
};

const AirlineCarrierBookableFlightNumbers = {
  displayName: 'Bookable Flight Numbers',
  dataAt: 'BookableFlightNumbers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierCheckInUrl = {
  displayName: 'Check-in Url',
  dataAt: 'CheckInUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierId = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarriersAdminPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Admin',
  children: [AirlineCarrierCreatedBy, AirlineCarrierCreatedOn, AirlineCarrierModifiedBy, AirlineCarrierModifiedOn]
};

const AirlineCarrierInternationalFlightNumbers = {
  displayName: "International Flight Numbers",
  dataAt: "InternationalFlightNumbers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const AirlineCarrierEnabled = {
  displayName: 'Enabled',
  dataAt: 'Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const AirlineCarrierTitle = {
  displayName: 'Title',
  dataAt: 'Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AirlineCarrierCode = {displayName: 'Code', dataAt: 'Code', displayAs: constants.DISPLAY_AS.TEXT_INPUT};

const AirlineCarriersInfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [AirlineCarrierId, AirlineCarrierTitle, AirlineCarrierCode, AirlineCarrierCheckInUrl, AirlineCarrierBookableFlightNumbers, AirlineCarrierInternationalFlightNumbers, AirlineCarrierCarrierLogoUrl, AirlineCarrierMediumImageUrl, AirlineCarrierCountryData, AirlineCarrierFareClasses, AirlineCarrierFareGdsSettings, AirlineCarrierFareRulesDocument, AirlineCarrierPartnerAirlines, AirlineCarrierEnabled]
};

const AirlineCarriersTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [AirlineCarriersInfoPanel, AirlineCarriersAdminPanel]
};

const AirlineCarrierNameLabel = {dataAt: 'Title', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Title:'};

const AirlineCarriersAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Airline Carrier',
  data: {Title: '', Code: ''},
  dataAt: '',
  children: [AirlineCarrierTitle, AirlineCarrierCode],
  endpoint: 'AirlineCarriers'
};

const AirlineCarriersResource = {
  displayName: 'Airline Carrier',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [AirlineCarrierNameLabel, AirlineCarriersTabs],
  endpoint: 'AirlineCarriers',
  routeParamId: 'airCarriersId'
};

const AirlineCarriersList = {
  rootNode: true,
  displayName: 'Airline Carriers',
  endpoint: 'AirlineCarriers',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: AirlineCarriersResource,
  gridAdd: AirlineCarriersAddResource,
  iconClass: 'fa-plane',
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Code', key: 'Code'},
      {name: 'Enabled', key: 'Enabled'}]
};

export default {
    AirlineCarriersList,AirlineCarriersResource,AirlineCarriersAddResource,AirlineCarrierNameLabel,AirlineCarriersTabs,AirlineCarrierEnabled,AirlineCarrierTitle,AirlineCarrierCode,AirlineCarriersInfoPanel,AirlineCarriersAdminPanel,AirlineCarrierId,AirlineCarrierCheckInUrl,AirlineCarrierBookableFlightNumbers,AirlineCarrierCarrierLogoUrl,AirlineCarrierMediumImageUrl,AirlineCarrierCountryData,AirlineCarrierFareClasses,AirlineCarrierFareGdsSettings,AirlineCarrierFareRulesDocument,AirlineCarrierPartnerAirlines,AirlineCarrierCreatedBy,AirlineCarrierCreatedOn,AirlineCarrierModifiedBy,AirlineCarrierModifiedOn,AirlineCarrierCountryDataGridItem,AirlineCarrierFareClassesGridItem,AirlineCarrierFareGdsSettingsItem,AirlineCarrierCountryDataCountry,AirlineCarrierCountryCheckInUrl,AirlineCarrierFareClassesTitle,AirlineCarrierFareClassesBrandName,AirlineCarrierFareClassesBookingCodes,AirlineCarrierFareClassesFareBasisCodes,AirlineCarrierFareClassesGroupType,AirlineCarrierFareClassesCountryFareClass,AirlineCarrierFareGdsSettingsName,AirlineCarrierFareGdsSettingsPreferredCountries,AirlineCarrierFareGdsSettingsFares,AirlineCarrierFareClassesCountryFareClassItem,AirlineCarrierFareGdsSettingsFaresItem,AirlineCarrierFareClassesCountryFareClassCountries,AirlineCarrierFareClassesCountryFareClassBrandName,AirlineCarrierFareClassesCountryFareClassBookingCodes,AirlineCarrierFareClassesCountryFareClassFareBasisCodes,AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries,AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType,AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType,AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes,AirlineCarrierFareGdsSettingsFaresItemFareData,AirlineCarrierFareGdsSettingsFaresItemFareDataItem,AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass,AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes,AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes,AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares,AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType,AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly, AirlineCarrierFareGdsSettingsPriceQuotes, AirlineCarrierFareGdsSettingsPriceQuotesItem, AirlineCarrierFareGdsSettingsPriceQuotesByBrand
}



// WEBPACK FOOTER //
// ./src/config/fields/airlineCarriers.js